import BrandedProgressBar from './BrandedProgressBar';

export default BrandedProgressBar;
